<svg
  preserveAspectRatio="xMidYMid meet"
  width="100%"
  viewBox="0 0 32 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  @switch (brand()) {
    @case ('recruitee') {
      <path
        d="M22.3611 0H9.63892C4.31549 0 0 4.31549 0 9.63892V22.3611C0 27.6845 4.31549 32 9.63892 32H22.3611C27.6845 32 32 27.6845 32 22.3611V9.63892C32 4.31549 27.6845 0 22.3611 0Z"
        fill="#ECE0F5"
      />
      <path
        d="M11.2432 14.7246C12.1473 14.7246 13.0144 15.0838 13.6537 15.7231C14.293 16.3624 14.6522 17.2295 14.6522 18.1336V22.5906C14.6522 23.0365 14.5644 23.4781 14.3937 23.8902C14.223 24.3022 13.9729 24.6766 13.6575 24.9919C13.3422 25.3073 12.9678 25.5574 12.5558 25.7281C12.1437 25.8988 11.7021 25.9866 11.2562 25.9866H7.8313V18.1322C7.83149 17.6844 7.9199 17.241 8.09148 16.8274C8.26307 16.4138 8.51446 16.038 8.8313 15.7216C9.14815 15.4051 9.52423 15.1542 9.93807 14.9831C10.3519 14.8121 10.7954 14.7242 11.2432 14.7246Z"
        fill="#5A1CB7"
      />
      <path
        d="M7.827 9.52654C7.827 11.4093 9.35326 12.9355 11.236 12.9355C13.1188 12.9355 14.645 11.4093 14.645 9.52654C14.645 7.6438 13.1188 6.11753 11.236 6.11753C9.35326 6.11753 7.827 7.6438 7.827 9.52654Z"
        fill="#E23393"
      />
      <path
        d="M24.0952 25.9844H20.6732C19.7725 25.9844 18.9088 25.6266 18.2719 24.9897C17.635 24.3528 17.2772 23.489 17.2772 22.5883V18.1314C17.2772 17.2273 17.6364 16.3602 18.2757 15.7209C18.915 15.0816 19.7821 14.7224 20.6862 14.7224C21.5903 14.7224 22.4574 15.0816 23.0967 15.7209C23.7361 16.3602 24.0952 17.2273 24.0952 18.1314V25.9844Z"
        fill="#5A1CB7"
      />
      <path
        d="M24.101 9.5262C24.101 7.64345 22.5747 6.11719 20.692 6.11719C18.8092 6.11719 17.283 7.64345 17.283 9.5262C17.283 11.4089 18.8092 12.9352 20.692 12.9352C22.5747 12.9352 24.101 11.4089 24.101 9.5262Z"
        fill="#5A1CB7"
      />
    }
    @case ('kiwi') {
      <path
        d="M22.3611 0H9.63892C4.31549 0 0 4.31549 0 9.63892V22.3611C0 27.6845 4.31549 32 9.63892 32H22.3611C27.6845 32 32 27.6845 32 22.3611V9.63892C32 4.31549 27.6845 0 22.3611 0Z"
        fill="#ECE0F5"
      />
      <path
        d="M26.5125 11.7759C26.5125 9.71641 24.8429 8.04688 22.7835 8.04688C20.724 8.04688 19.0544 9.71641 19.0544 11.7759C19.0544 13.8354 20.724 15.5049 22.7835 15.5049C24.8429 15.5049 26.5125 13.8354 26.5125 11.7759Z"
        fill="#E23393"
      />
      <path
        d="M6.69147 9.13951C7.39044 8.44054 8.33833 8.04769 9.32683 8.04731C10.3153 8.04693 11.2635 8.43904 11.963 9.13748L18.7064 15.8809C19.0529 16.2254 19.328 16.635 19.5159 17.0861C19.7038 17.5372 19.8009 18.0209 19.8015 18.5096C19.8022 18.9982 19.7064 19.4822 19.5198 19.9338C19.3331 20.3854 19.0591 20.7957 18.7136 21.1412L16.0635 23.7913L6.68637 14.4142C5.98704 13.7148 5.59417 12.7663 5.59417 11.7773C5.59417 10.7883 5.98704 9.83986 6.68637 9.14054L6.69147 9.13951Z"
        fill="#5A1CB7"
      />
    }
    @case ('javelo') {
      <rect width="28" height="28" rx="8" fill="#D14905" />
      <path
        d="M23.7607 18.7461L13.8298 22.5586L4.20902 18.746L13.8296 15.2267L23.7607 18.7461Z"
        fill="white"
        stroke="#D14905"
      />
      <path
        d="M23.9405 13.8239L13.8302 18.3522L4.03567 13.8238L13.83 9.64388L23.9405 13.8239Z"
        fill="white"
        stroke="#D14905"
      />
      <path
        d="M23.7607 8.9492L13.8298 12.7618L4.20902 8.94913L13.8296 5.42986L23.7607 8.9492Z"
        fill="white"
        stroke="#D14905"
      />
    }
  }
</svg>
